import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { apiRequest } from "../api/client";

const contactInfo = {
  email: "admin@femtyz.com",
  // phone: "+198765432100",
  address: "71-75 Shelton Street, Covent Garden, London, WC2H 9JQ",
};

function ContactUsV2({ onOpenAuth, onOpenMenu }) {
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [success, setSuccess] = useState("");

  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const PHONE_REGEX = /^[\d\s\-+()]{10,}$/;

  function validate() {
    const errs = {};
    const name = fullName.trim();
    const phone = phoneNumber.trim();
    const emailVal = email.trim();
    const subj = subject.trim();
    const msg = message.trim();

    if (!name) errs.full_name = "Full name is required.";
    else if (name.length > 30) errs.full_name = "Full name must be 30 characters or less.";

    if (!phone) errs.phone_number = "Phone number is required.";
    else if (!PHONE_REGEX.test(phone) || phone.replace(/\D/g, "").length < 10) {
      errs.phone_number = "Enter a valid phone number (at least 10 digits).";
    }

    if (!emailVal) errs.email = "Email is required.";
    else if (!EMAIL_REGEX.test(emailVal)) errs.email = "Enter a valid email address.";

    if (!subj) errs.subject = "Subject is required.";
    else if (subj.length > 100) errs.subject = "Subject must be 100 characters or less.";

    if (!msg) errs.message = "Message is required.";
    else if (msg.length > 250) errs.message = "Message must be 250 characters or less.";

    setFieldErrors(errs);
    return Object.keys(errs).length === 0;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setFieldErrors({});
    setSuccess("");
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await apiRequest("api/contact_us", {
        method: "POST",
        body: {
          full_name: fullName.trim(),
          phone_number: phoneNumber.trim(),
          email: email.trim(),
          subject: subject.trim(),
          message: message.trim(),
        },
      });

      if (res.ok) {
        setSuccess("Your message has been sent successfully.");
        setFullName("");
        setPhoneNumber("");
        setEmail("");
        setSubject("");
        setMessage("");
      } else {
        const msg = Array.isArray(res.data?.errors)
          ? res.data.errors.join("\n")
          : res.data?.message || "Something went wrong. Please try again.";
        setError(msg);
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#F5F7FB] text-[#24303A] flex flex-col">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto w-full max-w-full flex-1 px-4 py-10 md:px-6">
        <section className="mb-8">
          <h1 className="text-[24px] font-semibold text-[#24303A] md:text-[28px]">
            Contact Us
          </h1>
          <p className="mt-2 text-[16px] font-normal text-[#6E7B86]">
            Send a message and we will get back to you.
          </p>
        </section>

        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="space-y-3">
            <h2 className="text-[20px] font-semibold uppercase tracking-wider text-[#24303A]">
              Let us know how we can help you
            </h2>
            <p className="text-[16px] text-[#6E7B86] font-normal leading-relaxed">
            We’re here to help

            Have a question or need help saving on your shopping?
            Whether it’s comparing your basket or understanding your results, send us a message and we’ll get back to you as quickly as possible.
            </p>

            <div className="space-y-4">
              <button
                type="button"
                onClick={() => {
                  window.location.href = `mailto:${contactInfo.email}`;
                }}
                className="flex w-full items-center gap-3 rounded-xl border border-[#E6EAF0] bg-white px-4 py-3 text-left text-[16px] font-semibold text-[#6E7B86] hover:border-[#7352C7]/50 hover:bg-[#7352C7]/5 transition-colors"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full shadow-md border border-[#E6EAF0]">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-4 w-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <path d="m22 6-10 7L2 6" />
                  </svg>
                </span>
               <div className="font-normal text-[#6E7B86] text-[16px]">{contactInfo.email}</div> 
              </button>

              {/* <button
                type="button"
                onClick={() => {
                  window.location.href = `tel:${contactInfo.phone.replace(/\D/g, "")}`;
                }}
                className="flex w-full items-center gap-3 rounded-xl border border-[#E6EAF0] bg-white px-4 py-3 text-left text-[16px] font-semibold text-[#6E7B86] hover:border-[#7352C7]/50 hover:bg-[#7352C7]/5 transition-colors"
              >
                <span className="flex h-9 w-9 shrink-0 items-center shadow-md justify-center rounded-full text-[#6E7B86] border border-[#E6EAF0]">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-4 w-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <div className="font-normal text-[#6E7B86] text-[16px]">{contactInfo.phone}</div>
              </button> */}

              <div className="flex w-full items-center gap-3 rounded-xl border border-[#E6EAF0] bg-white px-4 py-3 text-left text-[16px] font-semibold text-[#6E7B86] hover:border-[#7352C7]/50 hover:bg-[#7352C7]/5 transition-colors">
                <span className="flex h-9 w-9 shrink-0 items-center shadow-md justify-center rounded-full text-[#6E7B86] border border-[#E6EAF0]">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-4 w-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
               
                <div className="font-normal text-[#6E7B86] text-[16px]"> {contactInfo.address}</div>

              </div>
            </div>
          </div>

          <div className="rounded-3xl border border-[#E6EAF0] bg-white px-6 py-6 shadow-sm">
            <h2 className="mb-6 text-lg font-semibold text-[#24303A]">Let&apos;s Talk</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="space-y-1">
                  <input
                    id="full_name"
                    type="text"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    placeholder="Full Name"
                    maxLength={30}
                    className={`w-full rounded-full border px-3 py-2 text-[16px] text-[#6E7B86] outline-none focus:border-[#7352C7] ${
                      fieldErrors.full_name
                        ? "border-red-400 bg-red-50"
                        : "border-slate-300 bg-white"
                    }`}
                  />
                  {fieldErrors.full_name && (
                    <p className="text-[16px] text-red-600">{fieldErrors.full_name}</p>
                  )}
                </div>
                <div className="space-y-1">
                  <input
                    id="phone_number"
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Phone Number"
                    className={`w-full rounded-full border px-3 py-2 text-[16px] text-[#6E7B86] outline-none focus:border-[#7352C7] ${
                      fieldErrors.phone_number
                        ? "border-red-400 bg-red-50"
                        : "border-slate-300 bg-white"
                    }`}
                  />
                  {fieldErrors.phone_number && (
                    <p className="text-[16px] text-red-600">{fieldErrors.phone_number}</p>
                  )}
                </div>
              </div>
              <div className="space-y-1">
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  className={`w-full rounded-full border px-3 py-2 text-[16px] text-[#6E7B86] outline-none focus:border-[#7352C7] ${
                    fieldErrors.email ? "border-red-400 bg-red-50" : "border-slate-300 bg-white"
                  }`}
                />
                {fieldErrors.email && <p className="text-[16px] text-red-600">{fieldErrors.email}</p>}
              </div>
              <div className="space-y-1">
                <input
                  id="subject"
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Subject"
                  maxLength={100}
                  className={`w-full rounded-full border px-3 py-2 text-[16px] text-[#6E7B86] outline-none focus:border-[#7352C7] ${
                    fieldErrors.subject
                      ? "border-red-400 bg-red-50"
                      : "border-slate-300 bg-white"
                  }`}
                />
                {fieldErrors.subject && (
                  <p className="text-[16px] text-red-600">{fieldErrors.subject}</p>
                )}
              </div>
              <div className="space-y-1">
                <textarea
                  id="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Message"
                  maxLength={250}
                  rows={4}
                  className={`w-full resize-none rounded-xl border px-3 py-2 text-[16px] text-[#6E7B86] outline-none focus:border-[#7352C7] ${
                    fieldErrors.message
                      ? "border-red-400 bg-red-50"
                      : "border-slate-300 bg-white"
                  }`}
                />
                {fieldErrors.message && (
                  <p className="text-[16px] text-red-600">{fieldErrors.message}</p>
                )}
              </div>

              {error && <p className="text-[16px] text-red-600">{error}</p>}
              {success && <p className="text-[16px] text-emerald-600">{success}</p>}

              <div className="flex justify-start pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="inline-flex items-center gap-2 rounded-full bg-[#7352C7] px-6 py-1.5 text-[16px] font-bold text-white disabled:opacity-60"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ContactUsV2;

